export const PROMISE_CACHE = new WeakMap();
export const getMemoizedPromiseFactory = (getPromise) => (...args) => {
    let functionCache = PROMISE_CACHE.get(getPromise);
    if (!functionCache) {
        functionCache = new Map();
        PROMISE_CACHE.set(getPromise, functionCache);
    }
    const cacheKey = JSON.stringify(args);
    const cachedPromise = functionCache.get(cacheKey);
    if (cachedPromise) {
        return cachedPromise;
    }
    const newPromise = getPromise(...args);
    functionCache.set(cacheKey, newPromise);
    newPromise.catch(() => {
        // remove newly added promises from the cache if they fail
        if (functionCache.get(cacheKey) === newPromise) {
            functionCache.delete(cacheKey);
        }
    });
    return newPromise;
};
//# sourceMappingURL=getMemoizedPromiseFactory.js.map